'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ApiClient2 = require('./ApiClient');

var _ApiClient3 = _interopRequireDefault(_ApiClient2);

var _UserApi = require('./api/UserApi');

var _UserApi2 = _interopRequireDefault(_UserApi);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApiClientRefreshToken = function (_ApiClient) {
    _inherits(ApiClientRefreshToken, _ApiClient);

    function ApiClientRefreshToken() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ApiClientRefreshToken);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ApiClientRefreshToken.__proto__ || Object.getPrototypeOf(ApiClientRefreshToken)).call.apply(_ref, [this].concat(args))), _this), _this.refreshApi = new _UserApi2.default(_this), _this.storageTokenFn = null, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ApiClientRefreshToken, [{
        key: 'setStorageFn',


        /**
         * @param storageToken function to store access token
         */
        value: function setStorageFn(storageToken) {
            if (storageToken && {}.toString.call(storageToken) === '[object Function]') this.storageTokenFn = storageToken;else console.warn('Store token function isn\'t a real function');
        }

        /** Client defined function
         * It set new authorization object as function parameter
         *
         * @type {null}
         */

    }, {
        key: 'callApi',


        /** Overwrite inherited method
         *
         * @param path
         * @param httpMethod
         * @param pathParams
         * @param queryParams
         * @param headerParams
         * @param formParams
         * @param bodyParam
         * @param authNames
         * @param contentTypes
         * @param accepts
         * @param returnType
         * @param callback
         * @returns {*|exports.Request}
         */
        value: function callApi(path, httpMethod, pathParams, queryParams, headerParams, formParams, bodyParam, authNames, contentTypes, accepts, returnType, apiBasePath, callback) {
            var _this2 = this;

            var url = this.buildUrl(path, pathParams);
            var request = (0, _superagent2.default)(httpMethod, url);

            // apply authentications
            this.applyAuthToRequest(request, authNames);

            // set query parameters
            if (httpMethod.toUpperCase() === 'GET' && this.cache === false) {
                queryParams['_'] = new Date().getTime();
            }

            request.query(this.normalizeParams(queryParams));

            // set header parameters
            request.set(this.defaultHeaders).set(this.normalizeParams(headerParams));

            // set requestAgent if it is set by user
            if (this.requestAgent) {
                request.agent(this.requestAgent);
            }

            // set request timeout
            request.timeout(this.timeout);

            var contentType = this.jsonPreferredMime(contentTypes);
            if (contentType) {
                // Issue with superagent and multipart/form-data (https://github.com/visionmedia/superagent/issues/746)
                if (contentType != 'multipart/form-data') {
                    request.type(contentType);
                }
            } else if (!request.header['Content-Type']) {
                request.type('application/json');
            }

            if (contentType === 'application/x-www-form-urlencoded') {
                request.send(_querystring2.default.stringify(this.normalizeParams(formParams)));
            } else if (contentType == 'multipart/form-data') {
                var _formParams = this.normalizeParams(formParams);
                for (var key in _formParams) {
                    if (_formParams.hasOwnProperty(key)) {
                        if (this.isFileParam(_formParams[key])) {
                            // file field
                            request.attach(key, _formParams[key]);
                        } else {
                            request.field(key, _formParams[key]);
                        }
                    }
                }
            } else if (bodyParam) {
                request.send(bodyParam);
            }

            var accept = this.jsonPreferredMime(accepts);
            if (accept) {
                request.accept(accept);
            }

            if (returnType === 'Blob') {
                request.responseType('blob');
            } else if (returnType === 'String') {
                request.responseType('string');
            }

            // Attach previously saved cookies, if enabled
            if (this.enableCookies) {
                if (typeof window === 'undefined') {
                    this.agent.attachCookies(request);
                } else {
                    request.withCredentials();
                }
            }

            request.end(function (error, response) {
                if (callback) {
                    var data = null;
                    if (!error) {
                        try {
                            data = _this2.deserialize(response, returnType);
                            if (_this2.enableCookies && typeof window === 'undefined') {
                                _this2.agent.saveCookies(response);
                            }
                        } catch (err) {
                            error = err;
                        }
                    } else if (error && response.status === 401) {

                        var errorJson = void 0;
                        try {
                            errorJson = JSON.parse(response.text);
                        } catch (err) {
                            callback(error, data, response);
                        }

                        if (errorJson.internal_error === 2) {
                            _this2.refreshApi.userRefreshAccessTokenGet(null, function (_error, _data, _res) {
                                if (!_error && _data && _data.access_token) {

                                    if (_this2.storageTokenFn) _this2.storageTokenFn(_data.access_token);

                                    if (headerParams.hasOwnProperty('Authorization')) {
                                        headerParams['Authorization'] = _data.access_token;
                                        _this2.callApi(path, httpMethod, pathParams, queryParams, headerParams, formParams, bodyParam, authNames, contentTypes, accepts, returnType, callback);
                                    }
                                } else {
                                    callback(error, data, response);
                                }
                            });
                        } else {
                            callback(error, data, response);
                        }
                    }

                    callback(error, data, response);
                }
            });

            return request;
        }
    }]);

    return ApiClientRefreshToken;
}(_ApiClient3.default);

exports.default = ApiClientRefreshToken;
//# sourceMappingURL=ApiClientRefreshToken.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/renderfarmapi/lib/lib-commonjs/ApiClientRefreshToken.js
// module id = 1451
// module chunks = 142